import { useState, useEffect } from 'react';

/** Nur `navigator.onLine` + Browser-Events (ohne Sync-Queue). Für KIAN-FAB „offline“. */
export function useNavigatorOnline(): boolean {
  const [online, setOnline] = useState(
    () => (typeof navigator !== 'undefined' ? navigator.onLine : true)
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return online;
}
